import { CfCard07Props } from "components/Cards/Card07/types";
import { ContentfulLivePreview } from "@contentful/live-preview";
import { LiveInspectorData } from "types/types";
import { convertCfImageProps } from "components/Image/CfImage";
import { useContentfulLiveUpdates } from "@contentful/live-preview/react";
import Card07, { Card07Props } from "components/Cards/Card07";
import React from "react";

const convertCfCard07 = ({
  abstract,
  hasParentLink,
  image,
  labelCta,
  title,
  contentful_id,
  headingLabelInfo,
  headingLabelType,
}: CfCard07Props) => {
  const liveInspector: LiveInspectorData = {
    card: ContentfulLivePreview.getProps({
      entryId: contentful_id || "",
      fieldId: "entryTitle",
    }),
  };

  const convertedProps: Card07Props = {
    text: typeof abstract === "string" ? abstract : (abstract?.abstract ?? ""),
    titleProps: title || "",
    imageProps: convertCfImageProps({
      ...image[0],
      customClass: "Card07__image-background__img",
    }),
    cta: labelCta?.[0]?.text?.text ?? "",
    liveInspector,
    hasParentLink: hasParentLink ?? true,
    headingLabelInfo: headingLabelInfo || "",
    headingLabelType: headingLabelType || "",
  };

  return convertedProps;
};

const CfCard07 = (props: CfCard07Props) => {
  const liveProps = useContentfulLiveUpdates({
    ...props,
    sys: { id: props.contentful_id },
  });

  return <Card07 {...convertCfCard07(liveProps)} />;
};

export default CfCard07;
